export const API_PUBLIC_KEY =
  process.env.REACT_APP_API_PUBLIC_KEY || "N0Al5Prsi2HEK8jpMnZRLTJS1IC7tO";
